import React from "react";
import { Container } from "./styles";
import TicketActions from "./TicketActions";
import TicketInfo from "./TicketInfo";

const Ticket = ({ data }) => (
  <Container>
    <TicketInfo info={data} />
    <TicketActions actions={data.actions} />
  </Container>
);

export default Ticket;
